import axios from 'App/axios';
import bffAxiosInstance from 'App/bffAxios';
import {
  PaymentProviderComparisonResult,
  PaymentProvidersComparisonParams,
} from 'commons/types';

export interface ConcessionPaymentProvidersResponse {
  enabled: boolean;
  storeId: number;
}

export const getConcessionPaymentProviders =
  async (): Promise<ConcessionPaymentProvidersResponse> => {
    try {
      const response = await axios.get<ConcessionPaymentProvidersResponse>(
        '/admin/payment-providers/concession',
      );
      return response.data;
    } catch (error) {
      return {
        enabled: false,
        storeId: 0,
      };
    }
  };

export const getPaymentProvidersComparison = async (
  params: PaymentProvidersComparisonParams,
): Promise<PaymentProviderComparisonResult[]> => {
  try {
    const response = await bffAxiosInstance.get<
      PaymentProviderComparisonResult[]
    >('payment-provider-rates', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};
